<template>
  <k-input
    type="currency"
    class="currency-input"
    :value="valueInDollars"
    :formatted-value="formattedCurrency"
    v-bind="$attrs"
    :size="$attrs.size || 7"
    :min="minValue"
    :max="maxValue"
    :error="showError"
    placeholder="0.00"
    :step="0.01"
    :rules="rules"
    @change="emitEvent('change', $event)"
    @input="emitEvent('input', $event)"
    @blur="hideErrors"
    @focus="hideErrors"
  >
  </k-input>
</template>

<script>
import KInput from './input.vue';
import InputMixin from './mixin.js';
import { roundAmount, isCurrencyAmountTooLow } from '../../utils';

function getValueToSend(value) {
  const isValueDefined = typeof value === 'string' && value.length;
  return isValueDefined ? (Number(value) * 100) : undefined;
}

export default {
  name: 'currency-input',

  mixins: [InputMixin],

  components: {
    KInput,
  },

  emits: ['input', 'change'],

  props: {
    value: Number,
    error: Boolean,
    withLowPaymentError: {
      type: Boolean,
      default: true,
    },
    min: Number,
    max: Number,
  },

  data() {
    return {
      isFocused: false,
    };
  },

  methods: {
    hideErrors() {
      this.isFocused = false;
      this.makeErrorsVisible();
    },

    emitEvent(event, value) {
      const valueToSend = getValueToSend(value);
      this.$emit(event, valueToSend);
      this.$emit('error', this.withLowPaymentError && isCurrencyAmountTooLow(value));
    },
  },

  computed: {
    formattedCurrency() {
      return (!!this.valueInDollars || this.valueInDollars === 0) && this.valueInDollars.toFixed(2);
    },

    valueInDollars() {
      return typeof this.value === 'number'
        ? roundAmount(this.value / 100)
        : roundAmount(Number(this.value) / 100);
    },

    minValue() {
      if (this.min !== undefined) {
        return roundAmount((Number(this.min) || 0) / 100);
      }
      return this.withLowPaymentError ? 0.5 : 0;
    },

    maxValue() {
      if (this.max !== undefined && !Number.isNaN(Number(this.max))) {
        return roundAmount(Number(this.max) / 100);
      }
      return undefined;
    },

    showError() {
      return this.withLowPaymentError ? (this.withLowPaymentError && isCurrencyAmountTooLow(this.value)) : false;
    },
  },
};
</script>
